





































import { Component } from 'vue-mixin-decorator';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';

import RepositoryFactory from '@/repository/RepositoryFactory';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
    },
  },
)
export default class UpdateInfoComplete extends BaseView {
  private examTitle = '';

  private mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    const CompleteCss = document.createElement('link');
    CompleteCss.rel = 'stylesheet';
    CompleteCss.href = '/account/css/complete.css';
    this.$el.appendChild(CompleteCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);

    this.getExamTitle();
  }

  /**
   * 検定タイトルを取得する
   */
  private getExamTitle() {
    try {
      const ExamRepository = RepositoryFactory.get().exam;
      ExamRepository.getExam()
        .then((response) => {
          this.examTitle = response.data.exam_title;
        })
        .catch(() => {
          // 完了画面なので何もしない
        });
    } catch (_) {
      // 完了画面なので何もしない
    }
  }
}
